/*
  cart-greeting-card.js
  Handles expand/collapse, card selection, direct writing on the card preview,
  character counter, live AJAX properties save, and status indicators.
*/

(function () {
  function initGreetingCards() {
    const cardSections = document.querySelectorAll('[data-greeting-card]');

    cardSections.forEach(function (container) {
      if (container.dataset.greetingCardInitialized === 'true') return;
      container.dataset.greetingCardInitialized = 'true';

      const itemIndex = parseInt(container.dataset.itemIndex, 10);
      const addBtn = container.querySelector('.gc-add-btn');
      const section = container.querySelector('.greeting-card-section');
      const removeLinks = container.querySelectorAll('.gc-remove-link');
      const thumbWrappers = container.querySelectorAll('.gc-thumb-wrapper');
      const cardPreview = container.querySelector('.gc-card-preview');
      const previewImg = container.querySelector('.gc-card-preview-img');
      const textarea = container.querySelector('.gc-card-textarea');
      const previewFooter = container.querySelector('.gc-preview-footer');
      const charCounter = container.querySelector('.gc-char-counter');
      const saveStatus = container.querySelector('.gc-save-status');

      const MAX_CHARS = 300;
      let selectedCard = null;
      let saveTimeout = null;

      // Use getAttribute to be completely safe from dataset parsing bugs
      const cardImageUrls = {
        '1': container.getAttribute('data-card-img-1'),
        '2': container.getAttribute('data-card-img-2')
      };

      // Find initially selected card
      const autoDesign = container.dataset.autoDesign || '1';
      if (cardPreview && cardPreview.classList.contains('visible')) {
        selectedCard = cardPreview.getAttribute('data-card') || autoDesign;
      }

      // Helper: find current quantity of the line item on the page
      function getCurrentQuantity() {
        const qtyInput = document.getElementById('Quantity-' + itemIndex) || 
                         document.getElementById('updates_' + itemIndex) ||
                         document.querySelector(`[name="updates[]"]:nth-child(${itemIndex})`) ||
                         document.querySelector(`.quantity__input[data-index="${itemIndex}"]`);
        
        if (qtyInput) {
          const val = parseInt(qtyInput.value, 10);
          return isNaN(val) ? 1 : val;
        }
        return 1; // Fallback
      }

      // Initial character count sync
      if (textarea) {
        updateCharCounter(textarea.value.length);
      }

      // ── Expand ──
      if (addBtn) {
        addBtn.addEventListener('click', function () {
          section.classList.add('open');
          addBtn.classList.add('hidden');

          // Automatically assign the pre-selected design based on tag
          selectedCard = autoDesign;

          // Show preview with correct image
          if (previewImg) {
            previewImg.src = cardImageUrls[selectedCard];
            previewImg.alt = 'Card Design ' + selectedCard;
          }
          if (cardPreview) {
            cardPreview.setAttribute('data-card', selectedCard);
            cardPreview.classList.add('visible');
          }
          if (previewFooter) {
            previewFooter.style.display = 'flex';
          }

          // Focus the card textarea so the user can immediately write
          if (textarea) {
            textarea.focus();
          }

          // Save immediately on card design assignment
          debouncedSave(true);
        });
      }

      // ── Collapse & Clear ──
      removeLinks.forEach(function (link) {
        link.addEventListener('click', function () {
          section.classList.remove('open');
          if (addBtn) addBtn.classList.remove('hidden');

          // Clear selections
          selectedCard = null;
          if (cardPreview) {
            cardPreview.classList.remove('visible');
            cardPreview.removeAttribute('data-card');
          }
          if (previewFooter) previewFooter.style.display = 'none';
          if (textarea) textarea.value = '';
          updateCharCounter(0);
          if (saveStatus) saveStatus.textContent = '';

          // Clear line item properties via AJAX
          saveProperties('', '');
        });
      });

      // ── Textarea Input → Update Live Counter & Save ──
      if (textarea) {
        let previousValue = textarea.value;

        textarea.addEventListener('input', function () {
          let text = this.value;

          // Enforce character limit
          if (text.length > MAX_CHARS) {
            text = text.substring(0, MAX_CHARS);
            this.value = text;
          }

          // Enforce visual boundary limit (prevent vertical scrolling/overflow)
          if (this.scrollHeight > this.clientHeight) {
            this.value = previousValue;
            updateCharCounter(this.value.length);
            return;
          }

          previousValue = this.value;
          updateCharCounter(this.value.length);

          // Save with debounce
          debouncedSave(false);
        });

        // Prevent the change event from bubbling up to Dawn's <cart-items> quantity validation
        textarea.addEventListener('change', function (event) {
          event.stopPropagation();
        });
      }

      // ── Save line item properties via Shopify Cart API ──
      function saveProperties(design, message) {
        const qty = getCurrentQuantity();
        const properties = {};

        if (design) {
          properties['Card Design'] = 'Design ' + design;
        } else {
          properties['Card Design'] = null; // Clear (null removes the property key in Shopify)
        }

        if (message) {
          properties['Card Message'] = message;
        } else {
          properties['Card Message'] = null; // Clear (null removes the property key in Shopify)
        }

        if (saveStatus) {
          saveStatus.textContent = 'Saving...';
          saveStatus.classList.add('saving');
        }

        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            line: itemIndex, // Shopify AJAX Cart API uses 1-based indexing for the line parameter
            quantity: qty,
            properties: properties
          })
        })
        .then(function (res) {
          return res.json();
        })
        .then(function (data) {
          if (saveStatus) {
            saveStatus.textContent = 'Saved';
            saveStatus.classList.remove('saving');
            setTimeout(function () {
              if (saveStatus.textContent === 'Saved') {
                saveStatus.textContent = '';
              }
            }, 2000);
          }
        })
        .catch(function (err) {
          console.warn('Greeting card: could not save properties', err);
          if (saveStatus) {
            saveStatus.textContent = 'Error saving';
            saveStatus.classList.remove('saving');
          }
        });
      }

      function debouncedSave(immediate) {
        clearTimeout(saveTimeout);
        const delay = immediate ? 0 : 800;
        saveTimeout = setTimeout(function () {
          saveProperties(selectedCard || '', textarea ? textarea.value : '');
        }, delay);
      }

      // ── Helper: Update character counter ──
      function updateCharCounter(count) {
        if (!charCounter) return;
        charCounter.textContent = count + '/' + MAX_CHARS;
        charCounter.classList.remove('near-limit', 'at-limit');
        if (count >= MAX_CHARS) {
          charCounter.classList.add('at-limit');
        } else if (count >= MAX_CHARS * 0.85) {
          charCounter.classList.add('near-limit');
        }
      }
    });
  }

  // Self-initializing safely
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGreetingCards);
  } else {
    initGreetingCards();
  }

  // Observe DOM changes to re-initialize on cart AJAX updates
  const observer = new MutationObserver(function () {
    initGreetingCards();
  });
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();
